import { BaseDropdownInterface } from '@interfaces/base-dropdown.interface';

/**
 * Compares 2 dropdown options by id, so that a new option object still shows as selected.
 */
export function compareDropdownById(first: unknown, second: unknown): boolean {
  return (first as BaseDropdownInterface | null)?.id === (second as BaseDropdownInterface | null)?.id;
}
